import { component } from 'picoapp';

export default component((node) => {
  /**
   * !TODO - Create search.js functions as exports or class methods,
   * !and import instead of nesting components
   * Makes it possible to keep search.js file on it's own template instead of all templates
   */

  const trigger = node.querySelector('[data-trigger]');
  const wrapper = node.querySelector('[data-quicksearch]');
  const form = node.querySelector('[data-form]');
  const input = form.querySelector('input[name="q"]');

  const openSearch = () => {
    wrapper.classList.add('is-active');
    wrapper.setAttribute('aria-hidden', false);

    setTimeout(() => input.focus(), 10);
  };

  const closeSearch = () => {
    wrapper.classList.remove('is-active');
    wrapper.setAttribute('aria-hidden', true);
  };

  trigger.addEventListener('click', (e) => {
    e.preventDefault();

    if (wrapper.classList.contains('is-active')) closeSearch();
    else openSearch();
  });

  document.addEventListener('click', (e) => {
    if (!node.contains(e.target) && !wrapper.contains(e.target)) closeSearch();
  });
});
